import { reloadBrowser } from '@/lib/browser-redirect';

const RELOAD_AT_KEY = 'chunk-reload-at';
// A second failure within this window means the reload already fetched the new
// index.html and the chunk is still unreachable, so another reload would loop.
const RELOAD_GUARD_MS = 60_000;

const chunkLoadErrors = new WeakSet<Error>();

// Vite rethrows the payload object itself, so React.lazy and the error boundary
// receive this exact instance. Membership is exact where message matching is
// not: every browser words the error differently.
export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && chunkLoadErrors.has(error);
}

export function installChunkLoadRecovery(): void {
  // No preventDefault: Vite would then resolve the import with undefined and
  // the boundary would receive an unrecorded TypeError instead of the payload.
  window.addEventListener('vite:preloadError', (event) => {
    chunkLoadErrors.add(event.payload);

    // index.html is served no-store: offline, a reload swaps the running app
    // for the browser's error page instead of fetching the new build.
    if (!navigator.onLine) return;

    const lastReloadAt = Number(sessionStorage.getItem(RELOAD_AT_KEY));
    if (Date.now() - lastReloadAt < RELOAD_GUARD_MS) return;

    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
    reloadBrowser();
  });
}
